import { DisplayObject } from "@pixi/display";

export class AnimationTargetProvider {
    private registrations: Map<string, DisplayObject>;

    public constructor() {
        this.registrations = new Map<string, DisplayObject>();
    }

    public register(key: string, target: DisplayObject): void {
        this.registrations.set(key, target);
    }

    public resolve(key: string): DisplayObject {
        if (!this.registrations.has(key)) {
            throw new Error(`No animation target registereg for key ${key}.`);
        }
        return this.registrations.get(key);
    }
}